// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const DISABLED = '@auth/DISABLED';
export const NOTVERIFIED = '@auth/NOTVERIFIED';
